type DataLayerEntry = unknown[] | Record<string, unknown>;
type AnalyticsWindow = Window & {
    dataLayer?: DataLayerEntry[];
    __smartGuideGtmLoaded?: boolean;
};

export const googleTagManagerScriptId = "smartguide-google-tag-manager";

export function loadGoogleTagManager(
    documentRef: Document,
    windowRef: Window,
    containerId: string,
    now: () => number = Date.now
): boolean {
    const normalizedContainerId = containerId.trim();
    if (!/^GTM-[A-Z0-9]+$/.test(normalizedContainerId)) return false;

    const analyticsWindow = windowRef as AnalyticsWindow;
    if (analyticsWindow.__smartGuideGtmLoaded || documentRef.getElementById(googleTagManagerScriptId)) {
        return false;
    }

    analyticsWindow.__smartGuideGtmLoaded = true;
    analyticsWindow.dataLayer ??= [];
    analyticsWindow.dataLayer.push([
        "consent",
        "default",
        {
            analytics_storage: "granted",
            ad_storage: "granted",
            ad_user_data: "granted",
            ad_personalization: "granted"
        }
    ]);
    analyticsWindow.dataLayer.push({ "gtm.start": now(), event: "gtm.js" });

    const script = documentRef.createElement("script");
    script.id = googleTagManagerScriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(normalizedContainerId)}`;
    script.addEventListener("error", () => undefined, { once: true });

    try {
        documentRef.head.appendChild(script);
    } catch {
        return false;
    }

    return true;
}
